import { createAction } from '../utils/createAction';

export const SORT_CHAGE_FILTER = 'Set Analytics Search Sort Filter';
export const COLOR_CHANGE_FILTER = 'Set Analytics Search Color Filter';
export const SEARCH_CHANGE_FILTER = 'Set Analytics Search Text Filter';

export const setSearchColorChange = ({
  colors, selectedColorFilters, selectedColorSort, searchString, surfaces
}) => (
  createAction(
    COLOR_CHANGE_FILTER,
    () => ({
      colors, selectedColorFilters, selectedColorSort, searchString, surfaces
    }),
  ))();

export const setSearchSortChange = ({ selectedColorSort }) => (
  createAction(
    SORT_CHAGE_FILTER,
    () => ({ selectedColorSort }),
  ))();

export const setSearchTextChange = ({
  colors, selectedColorFilters, selectedColorSort, searchString, surfaces
}) => (
  createAction(
    SEARCH_CHANGE_FILTER,
    () => ({
      colors, selectedColorFilters, selectedColorSort, searchString, surfaces
    }),
  ))();